export class Alert{
    constructor(obj) {
        if (!obj) {
            return;
        }

        this.dismissible = !!obj.dismissible;
        this.message = obj.message;
        this.color = obj.color;
        this.type = obj.type;
        this.outlined = !!obj.outlined;
        this.errorObj = obj.errorObj;
    }
}

export class AppError extends Alert {

    constructor(message,errorObj) {
        super({
            dismissible: true,
            message,
            color: 'red',
            type: 'error',
            errorObj
        });
    }
}
